import { useRouter } from 'next/router'
import React, { useState } from 'react'

import { DocumentSettingCta } from 'src/components/organisms'

export const CtaContainer = ({ onClose }: { onClose?: () => void }) => {
  const { query } = useRouter()
  const { documentId } = query as { documentId: string }

  const [open, setOpen] = useState(true)
  const handleClose = () => {
    setOpen(false)
    onClose?.()
  }

  return documentId ? <DocumentSettingCta open={open} onClose={handleClose} documentId={documentId} /> : <></>
}
